module.exports = "/dist/assets/images/creditcard-logo.svg";